module.exports = __webpack_public_path__ + "static/img/17.c798daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/17.png
// module id = LUsI
// module chunks = 35